import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";

const OfferDialog = ({ open, onClose, onSave, offer, onChange, isEditMode }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{isEditMode ? "Edit Offer" : "Add New Offer"}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Title"
          value={offer?.title || ""}
          onChange={(e) => onChange("title", e.target.value)}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Caption"
          value={offer?.caption || ""}
          onChange={(e) => onChange("caption", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Description"
          value={offer?.description || ""}
          onChange={(e) => onChange("description", e.target.value)}
          margin="normal"
          multiline
          minRows={3}
          maxRows={6}
        />
        <TextField
          fullWidth
          label="Validity From"
        //   type="datetime-local"
          value={offer?.validityFrom || ""}
          onChange={(e) => onChange("validityFrom", e.target.value)}
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          fullWidth
          label="Validity To"
        
          value={offer?.validityTo|| ""}
          onChange={(e) => onChange("validityTo", e.target.value)}
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          fullWidth
          label="Coupon"
          value={offer?.coupon || ""}
          onChange={(e) => onChange("coupon", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Offer Highlight"
          value={offer?.offerHighlight || ""}
          onChange={(e) => onChange("offerHighlight", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Amount Strikethrough"
          value={offer?.amountStrikethrough || ""}
          onChange={(e) => onChange("amountStrikethrough", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Amount Active"
          value={offer?.amountActive || ""}
          onChange={(e) => onChange("amountActive", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Button Text"
          value={offer?.buttonText || ""}
          onChange={(e) => onChange("buttonText", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          select
          label="Button Action Type"
          value={offer?.buttonActionType || ""}
          onChange={(e) => onChange("buttonActionType", e.target.value)}
          margin="normal"
        >
          <MenuItem value="CALL">CALL</MenuItem>
          <MenuItem value="LINK">LINK</MenuItem>
        </TextField>
        <TextField
          fullWidth
          label="Button Action"
          value={offer?.buttonAction || ""}
          onChange={(e) => onChange("buttonAction", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          select
          label="Media Type"
          value={offer?.mediaType || ""}
          onChange={(e) => onChange("mediaType", e.target.value)}
          margin="normal"
        >
          <MenuItem value="IMAGE">IMAGE</MenuItem>
          <MenuItem value="VIDEO">VIDEO</MenuItem>
        </TextField>
        <TextField
          fullWidth
          label="URL"
          value={offer?.url || ""}
          onChange={(e) => onChange("url", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Color"
          value={offer?.color || ""}
          onChange={(e) => onChange("color", e.target.value)}
          margin="normal"
        //   type="color"
        />
        <TextField
          fullWidth
          label="Priority"
          type="number"
          value={offer?.priority || ""}
          onChange={(e) => onChange("priority", e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          select
          label="Offers Type"
          value={offer?.offersType || ""}
          onChange={(e) => onChange("offersType", e.target.value)}
          margin="normal"
        >
          <MenuItem value="Offers1x1">Offers1x1</MenuItem>
          <MenuItem value="Offers1x2">Offers1x2</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary">
          {isEditMode ? "Save Changes" : "Add Offer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OfferDialog;
